import { useState } from 'react';
import { addDays, format } from 'date-fns';
import PropTypes from 'prop-types';
import { FORMAT_US_DATE } from 'utils/helpers/datetime';
import Calendar from 'components/calendar';

const SearchWidget = ({ title, baseUrl }) => {
  const [date, setDate] = useState(addDays(new Date(), 1));
  const [nights, setNights] = useState('1');
  const [adults, setAdults] = useState('1');
  const [children, setChildren] = useState('0');

  return (
    <div className="position-relative">
      <div className="search-widget-of-sea-breeze d-lg-flex container-lg m-auto">
        <div className="flex-grow-0 search-widget--title text-white bg-primary lh-sm">
          <span>{title || 'Rooms from $199'}</span>
        </div>
        <div className="flex-grow-1 row align-items-center g-3 m-3">
          <div className="col-6 col-lg-3">
            <label className="form-label">Check-in Date</label>
            <div className="input-with-icon input-with-icon--on-right">
              <Calendar
                value={date}
                inputProps={{
                  placeholder: 'Select date',
                }}
                className="form-control w-100"
                onChange={({ value }) => {
                  setDate(value);
                }}
                cssClass="mobiscroll-classic"
                dateFormat="MM/DD/YYYY"
              />
              <div className="input-with-icon__icon">
                <i className="far fa-calendar-alt" />
              </div>
            </div>
          </div>
          <div className="col-6 col-lg-3">
            <label htmlFor="search-widget-nights" className="form-label">
              Nights
            </label>
            <select
              className="form-select"
              aria-label="Nights"
              id="search-widget-nights"
              value={nights}
              onChange={(e) => setNights(e.target.value)}
            >
              <option value={1}>1 Night</option>
              {Array.from({ length: 19 }, (_, i) => i + 2).map((v) => (
                <option key={v} value={v}>
                  {v} Nights
                </option>
              ))}
            </select>
          </div>
          <div className="col-6 col-lg-3">
            <label htmlFor="search-widget-adults" className="form-label">
              Adults
            </label>
            <select
              className="form-select"
              aria-label="Adults"
              id="search-widget-adults"
              value={adults}
              onChange={(e) => setAdults(e.target.value)}
            >
              <option value={1}>1 Adult</option>
              {Array.from({ length: 9 }, (_, i) => i + 2).map((v) => (
                <option key={v} value={v}>
                  {v} Adults
                </option>
              ))}
            </select>
          </div>
          <div className="col-6 col-lg-3">
            <label htmlFor="search-widget-children" className="form-label">
              Children
            </label>
            <select
              className="form-select"
              aria-label="Children"
              id="search-widget-children"
              value={children}
              onChange={(e) => setChildren(e.target.value)}
            >
              <option value={0}>0 Children</option>
              <option value={1}>1 Child</option>
              {Array.from({ length: 9 }, (_, i) => i + 2).map((v) => (
                <option key={v} value={v}>
                  {v} Children
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="flex-grow-0 search-widget--submit-btn">
          <a
            type="button"
            className="search-widget--submit-btn-text btn btn-primary d-lg-flex align-items-center justify-content-between lh-sm"
            target="_self"
            href={`${baseUrl}&adults=${adults}&children=${children}${
              date ? `&datein=${format(date, FORMAT_US_DATE)}` : ''
            }&domain=${
              window.location.origin
            }&languageid=11&Length=${nights}#/guestsandrooms`}
          >
            <span>BOOK NOW &nbsp;</span>
            <i className="fa-solid fa-chevron-right" />
          </a>
        </div>
      </div>
    </div>
  );
};

SearchWidget.propTypes = {
  baseUrl: PropTypes.string,
  title: PropTypes.string,
};

export default SearchWidget;
